import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    _classCallCheck(this, Index);

    return _super.apply(this, arguments);
  }

  _createClass(Index, [{
    key: "finalData",
    // data = [
    //     ['14:00~14:10', '主持人开场', 'h', '待确认'],
    //     ['14:00~14:10', '主持人开场', '', '待确认'],
    //     ['14:00~14:10', '主持人开场', '', '待确认'],
    //     ['14:00~14:10', '主持人开场', '', '待确认'],
    // ]
    get: function get() {
      if (+this.rows) {
        var res = [];

        for (var i = 0; i < +this.rows; i++) {
          if (this.data[i]) {
            res.push(this.data[i]);
          } else {
            res.push(['　', '', '', '']);
          }
        }

        return res;
      } else {
        return this.data;
      }
    }
  }]);

  return Index;
}(Vue);

__decorate([Prop({
  required: true,
  default: []
})], Index.prototype, "data", void 0);

__decorate([Prop()], Index.prototype, "rows", void 0);

Index = __decorate([Component({
  name: 'MyTable',
  components: {}
})], Index);
export default Index;